import { FC } from 'react';

import CustomLoading from 'modules/_shared/components/CustomLoading';

import AcceptIncentiveOfferModalHeader from './components/AcceptIncentiveOfferModalHeader';
import AcceptIncentiveOfferModalBody from './components/AcceptIncentiveOfferModalBody';
import AcceptIncentiveOfferModalFooter from './components/AcceptIncentiveOfferModalFooter';

import { useAcceptIncentiveOfferModal } from './context/AcceptIncentiveOfferModalContext';

const AcceptIncentiveOfferModal: FC = () => {
  const { data } = useAcceptIncentiveOfferModal();

  return (
    <>
      <AcceptIncentiveOfferModalHeader />
      <AcceptIncentiveOfferModalBody />
      <AcceptIncentiveOfferModalFooter />

      {data.isLoading && <CustomLoading />}
    </>
  );
};

export default AcceptIncentiveOfferModal;
